// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ah35","title":"styles_title__1BvUo"};